// extracted by mini-css-extract-plugin
export default {"mobile":"style_mobile__XLh+E","active":"style_active__gaT7D","laptop":"style_laptop__Bm-9w"};